/**
 * Bygger på epi-parametern i affiliate-länkarna med besökarens attribution.
 *
 * Bakgrund: tidigare gick köp-länkarna via /goto/-redirecten, där
 * OutLinkNewController läste gclid/gbraid/wbraid ur adressfältet och
 * GA-klient-ID ur _ga-cookien och la på svansen innan den byggde
 * affiliate-URL:en. Nu renderas affiliate-länken direkt i HTML:en och hamnar i
 * den statiska cachen, som delas av alla besökare — den delen måste därför
 * läggas på i webbläsaren i stället.
 *
 * Servern renderar data-epiparam på varje köp-länk (SalesObject::getEpiParam),
 * eftersom parameternamnet är konfigurerbart per återförsäljare och inte går
 * att gissa ur URL:en. Tomt attribut = länken har ingen epi och lämnas i fred.
 *
 * Svansformatet är exakt det OutLinkNewController byggde:
 *   gclid  -> --ppc--<clientId>--<gclid>
 *   gbraid -> --ppc+b--<clientId>--<gbraid>
 *   wbraid -> --ppc+w--<clientId>--<wbraid>
 *   annars -> --org--<clientId>--0
 */
var AffiliateEpi = function() {

    var ORIGINAL = "epiOriginalHref";
    var APPLIED = "epiAppliedFor";

    var WINDOW = 604800;
    var now = Math.floor(Date.now() / 1000);
    var saved = null;
    function cookie(name) {
        var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
        try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
    }
    try { saved = JSON.parse(cookie('affiliate_ads_click') || 'null'); } catch (e) {}
    if (saved && (!saved.captured_at || saved.captured_at > now || now - saved.captured_at >= WINDOW
        || !/^(gclid|gbraid|wbraid)$/.test(saved.field) || typeof saved.id !== 'string')) saved = null;
    if (!saved) {
        var query = new URLSearchParams(window.location.search);
        ['gclid', 'gbraid', 'wbraid'].some(function(field) {
            var id = query.get(field);
            if (!id || id.length > 2048 || /[\x00-\x1f\x7f]/.test(id)) return false;
            saved = {field: field, id: id, captured_at: now}; return true;
        });
    }
    if (saved && cookie('cookie-consent') !== 'reject') {
        document.cookie = 'affiliate_ads_click=' + encodeURIComponent(JSON.stringify(saved))
            + '; Path=/; SameSite=Lax; Max-Age=' + Math.max(0, saved.captured_at + WINDOW - now)
            + (window.location.protocol === 'https:' ? '; Secure' : '');
    }
    function queryParam(name) {
        return saved && Math.floor(Date.now() / 1000) - saved.captured_at < WINDOW && cookie('cookie-consent') !== 'reject' && saved.field === name ? saved.id : '';
    }

    /**
     * GA-klient-ID. Cookien sätts av GA-scriptet och kan saknas precis vid
     * sidladdning — därför körs omskrivningen om vid klick.
     */
    function clientId() {
        if (cookie('cookie-consent') === 'reject') return '';
        try {
            if (typeof ga !== "undefined" && ga.getAll && ga.getAll()[0]) {
                return ga.getAll()[0].get("clientId") || "";
            }
        } catch (err) {
            // Faller igenom till cookien nedan.
        }

        var match = document.cookie.match(/_ga=GA1\.\d+\.(\d+\.\d+)/);

        return match ? match[1] : "";
    }

    /**
     * @return {{tail: string, adId: string}|null}
     */
    function attribution() {
        var gclid = queryParam("gclid");
        var gbraid = queryParam("gbraid");
        var wbraid = queryParam("wbraid");
        var cid = clientId();

        if (gclid) {
            return { tail: "--ppc--" + cid + "--" + gclid, adId: gclid };
        }

        if (gbraid) {
            return { tail: "--ppc+b--" + cid + "--" + gbraid, adId: gbraid };
        }

        if (wbraid) {
            return { tail: "--ppc+w--" + cid + "--" + wbraid, adId: wbraid };
        }

        if (cid) {
            return { tail: "--org--" + cid + "--0", adId: "" };
        }

        return null;
    }

    /**
     * "&epi=" / "?epi=" / "epi" -> "epi"
     */
    function paramName(raw) {
        return (raw || "").replace(/^[?&]+/, "").replace(/=+$/, "");
    }

    /**
     * Skriver om en länk. Alltid utifrån originalet, så funktionen kan köras
     * flera gånger utan att svansen dubbleras.
     */
    function apply(el, attr) {
        var name = paramName(el.getAttribute("data-epiparam"));

        if (!name) {
            return;
        }

        if (el.dataset.epiGeneratedHref && el.getAttribute('href') !== el.dataset.epiGeneratedHref) {
            delete el.dataset[ORIGINAL]; delete el.dataset[APPLIED];
        }
        if (!el.dataset[ORIGINAL]) {
            el.dataset[ORIGINAL] = el.getAttribute("href") || "";
        }

        var href = el.dataset[ORIGINAL];
        var destination = href.search(/[?&](?:url|ued)=/i);
        var outer = destination === -1 ? href : href.slice(0, destination);
        var inner = destination === -1 ? '' : href.slice(destination);
        outer = outer.replace(/([?&])(?:epi2|uid2)=[^&#]*/g, function(m, prefix) { return prefix === '?' ? '?' : ''; }).replace(/\?&/, '?');
        href = outer + inner;

        if (!href) {
            return;
        }

        // Kör inte om i onödan när ingenting förändrats sedan förra gången.
        var signature = attr ? attr.tail : "";

        if (el.dataset[APPLIED] === signature) {
            return;
        }

        if (!attr) {
            el.setAttribute("href", href);
            el.dataset[APPLIED] = "";
            return;
        }

        // Strängersättning i stället för URL-objekt: affiliate-länkarna har
        // ofta destinationen oencodad i "&url=https://...", och en runda
        // genom URLSearchParams skulle procent-encoda den och kunna sabba
        // länken hos nätverket.
        var pattern = new RegExp("([?&]" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "=)([^&#]*)");

        if (!pattern.test(outer)) {
            el.dataset[APPLIED] = signature;
            return;
        }

        var addition = encodeURIComponent(attr.tail);

        // epi2/uid2 låg i OutLinkNewController direkt efter epi-värdet, alltså
        // före "&url=". Samma placering här — läggs den sist i URL:en riskerar
        // den att tolkas som en del av destinationen.
        if (attr.adId && /(?:partner-ads|adrecord|track\.adtraction)/i.test(href)) {
            var second = /partner-ads/.test(href) ? "uid2" : "epi2";
            addition += "&" + second + "=" + encodeURIComponent(attr.adId);
        }

        el.setAttribute("href", outer.replace(pattern, function (match, prefix, value) {
            var decoded;
            try { decoded = decodeURIComponent(value); } catch (e) { decoded = value; }
            // Replace a pre-existing visitor suffix, never append twice.
            decoded = decoded.replace(/--(?:ppc(?:[+ _]?[bw])?|org)--.*$/i, '');
            return prefix + encodeURIComponent(decoded) + addition;
        }) + inner);
        el.dataset.epiGeneratedHref = el.getAttribute("href");

        el.dataset[APPLIED] = signature;
    }

    function applyAll() {
        var attr = attribution();
        var links = document.querySelectorAll("a[data-epiparam]");

        for (var i = 0; i < links.length; i++) {
            apply(links[i], attr);
        }
    }

    // Vid sidladdning: täcker mittenklick, "öppna i ny flik" och
    // "kopiera länkadress", som aldrig triggar en klicklyssnare.
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", applyAll);
    } else {
        applyAll();
    }

    // Vid klick: GA-cookien kan ha hunnit sättas efter sidladdningen, och
    // länkar som lagts till dynamiskt fångas här.
    function updateForEvent(e) {
        var el = e.target && e.target.closest ? e.target.closest("a[data-epiparam]") : null;

        if (el) {
            apply(el, attribution());
        }
    }
    ['pointerdown', 'mousedown', 'touchstart', 'click', 'contextmenu', 'keydown'].forEach(function(name) {
        document.addEventListener(name, updateForEvent, true);
    });
    if (typeof MutationObserver === 'function') {
        new MutationObserver(function(records) {
            if (records.some(function(r) { return r.type === 'attributes' || r.addedNodes.length > 0; })) applyAll();
        }).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'data-epiparam']});
    }
};

module.exports = AffiliateEpi;
